module.exports = __webpack_public_path__ + "img/myapp-es.3cf9f1b9.png";